import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = {
  key: 0,
  class: "ant-input-wrapper ant-input-group ss-alinhar-texto-direita"
}
const _hoisted_17 = { class: "ant-input-group-addon" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-22" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_22 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"15px","margin-bottom":"5px"}
}, null, -1)
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_plano_assinatura = _resolveComponent("selecionar-tipo-plano-assinatura")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_nivel_atendimento_assinatura = _resolveComponent("selecionar-nivel-atendimento-assinatura")!
  const _component_selecionar_ambiente = _resolveComponent("selecionar-ambiente")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 900
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro - Plano de Assinaturas "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.planoAssinatura.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.planoAssinatura.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                    || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_plano_assinatura, {
                          valor: _ctx.state.planoAssinatura.tipo,
                          "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.planoAssinatura.tipo) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Nível Suporte",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_nivel_atendimento_assinatura, {
                          valor: _ctx.state.planoAssinatura.nivelAtendimento,
                          "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.planoAssinatura.nivelAtendimento) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_form_item, {
                      label: "Nome",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.planoAssinatura.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.planoAssinatura.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "Identificador",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.planoAssinatura.identificador) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.planoAssinatura.identificador]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Ambiente",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_ambiente, {
                          codigoSelecionado: _ctx.state.planoAssinatura.codigoAmbiente,
                          "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.planoAssinatura.codigoAmbiente) = $event))
                        }, null, 8, ["codigoSelecionado"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_form_item, {
                      label: "Ambiente Exclusivo?",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_sim_nao, {
                          valor: _ctx.state.planoAssinatura.ambienteExclusivo,
                          "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.planoAssinatura.ambienteExclusivo) = $event)),
                          radioButton: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, {
                      label: "E-mails para receber Novas Contratações/Contatos",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.planoAssinatura.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.planoAssinatura.email]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_form_item, {
                      label: "Solicitar Contato?",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_sim_nao, {
                          valor: _ctx.state.planoAssinatura.solicitarContato,
                          "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.planoAssinatura.solicitarContato) = $event)),
                          radioButton: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_editor_html, {
                          value: _ctx.state.planoAssinatura.descricao,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.planoAssinatura.descricao) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "1",
                      tab: "LIMITES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.planoAssinatura.limites, (limitePlano, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "ant-col ant-col-xs-24 ant-col-xl-6"
                                }, [
                                  _createVNode(_component_a_form_item, {
                                    label: limitePlano.titulo,
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      (limitePlano.identificador === 'ESPACO')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                            _createVNode(_component_campo_numerico, {
                                              permitirValorNegativo: false,
                                              quantidadeCasasDecimais: 0,
                                              valor: limitePlano.limite,
                                              "onUpdate:valor": ($event: any) => ((limitePlano.limite) = $event),
                                              onUpdate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.atualizarApresentacaoEspaco($event))),
                                              onChange: ($event: any) => (_ctx.atualizarApresentacaoEspaco(limitePlano.limite))
                                            }, null, 8, ["valor", "onUpdate:valor", "onChange"]),
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.state.apresentacaoEspaco), 1)
                                          ]))
                                        : (_openBlock(), _createBlock(_component_campo_numerico, {
                                            key: 1,
                                            permitirValorNegativo: false,
                                            quantidadeCasasDecimais: 0,
                                            valor: limitePlano.limite,
                                            "onUpdate:valor": ($event: any) => ((limitePlano.limite) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"]))
                                    ]),
                                    _: 2
                                  }, 1032, ["label"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "2",
                      tab: "DETALHES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            (_ctx.state.planoAssinatura.detalhes.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  mensagem: "Nenhum detalhe adicionado ainda"
                                }))
                              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.planoAssinatura.detalhes, (detalhe, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "ant-row ss-grade-personalizada-linha",
                                      key: index
                                    }, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_a_form_item, {
                                          label: " ",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.adicionarDetalhe()), ["enter"])),
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.state.planoAssinatura.detalhes[index].detalhe) = $event)
                                            }, null, 40, _hoisted_20), [
                                              [_vModelText, _ctx.state.planoAssinatura.detalhes[index].detalhe]
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_a_form_item, { label: " " }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_22, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "ant-btn ant-btn-primary ant-btn-dangerous ss-tamanho-completo",
                                                title: "Excluir detalhe",
                                                onClick: ($event: any) => (_ctx.removerDetalhe(index))
                                              }, [
                                                _createVNode(_component_icone, { nome: "excluir" })
                                              ], 8, _hoisted_23)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]))
                                  }), 128))
                                ])),
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-primary ss-tamanho-completo",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.adicionarDetalhe()))
                                }, "Novo detalhe")
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.removerTodosDetalhes()))
                                }, "Remover Todos")
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "3",
                      tab: "MÓDULOS"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_28, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.modulosSelecionados, (modulo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "ant-col ant-col-xs-24 ant-col-xl-6"
                                }, [
                                  _createVNode(_component_a_checkbox, {
                                    class: "ss-margin-campos",
                                    checked: modulo.selecionado,
                                    "onUpdate:checked": ($event: any) => ((modulo.selecionado) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(modulo.titulo), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["checked", "onUpdate:checked"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "4",
                      tab: "VALORES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.planoAssinatura.valores, (valorPlano, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "ant-col ant-col-xs-24 ant-col-xl-6"
                                }, [
                                  _createVNode(_component_a_form_item, {
                                    label: _ctx.obterTituloValor(valorPlano.recorrencia),
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_campo_numerico, {
                                        monetario: true,
                                        valor: valorPlano.valor,
                                        "onUpdate:valor": ($event: any) => ((valorPlano.valor) = $event)
                                      }, null, 8, ["valor", "onUpdate:valor"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}